import styled from 'styled-components/macro';

import { ThemedCircleButton } from 'components/ThemedCircleButton';
import { large } from 'styles/breakpoints';
import { container, containerTall, removeCarouselPadding } from 'styles/layout';
import { description } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const FormGroup = styled.div`
  ${containerTall}
`;

export const Container = styled.div`
  width: 100%;
`;
export const HeaderLower = styled.h1`
  ${description}

  font-weight: initial;
  margin: 23px 0 23px;
  text-align: center;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const Buttons = styled.div`
  ${container}

  margin-top: 8px;
`;

export const MediaContainer = styled.div`
  ${removeCarouselPadding}

  display: flex;
  height: 293px;
  justify-content: center;
  position: relative;

  ${({ theme }: IWithThemeProps) => `
    background-color: ${theme.bottomForegroundPrimary};
  `}

  ${large`
    height: 351px;
  `}
`;

export const Media = styled.video`
  height: 100%;
  max-width: 100%;
  object-fit: scale-down;
`;

export const CloseButton = styled(ThemedCircleButton)`
  & {
    background: transparent;
    border: 0;
    cursor: pointer;
    height: 40px;
    padding: 0;
    position: absolute;
    right: 2.3%;
    top: -20px;
    width: 40px;

    ${({ theme }: IWithThemeProps) => `
      [data-svg-class="Close-circle"] {
        stroke: ${theme.bottomForegroundActionPrimary};
        fill: ${theme.bottomForegroundActionSecondary};
      }

      [data-svg-class="Close-line"] {
        stroke: ${theme.bottomForegroundActionPrimary};
      }

      &:hover {
        [data-svg-class="Close-circle"] {
          fill: ${theme.bottomForegroundActionPrimary};
        }

        [data-svg-class="Close-line"] {
          stroke: ${theme.bottomForegroundActionSecondary};
        }
      }
    `}
  }
`;
